import React from 'react'
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';

import Container from '../../layout/container'
import { SpecialStyle, SliderItem } from './style'

import Img1 from '../../assets/special/img1.png';
import Img2 from '../../assets/special/img2.png';
import Img3 from '../../assets/special/img3.png';
import Img4 from '../../assets/special/img4.png';

const items = [
  {
    id: 1,
    title: 'Producto',
    subtitle: 'Perfumería, maquillaje, cuerpo y cabello',
    img: Img1,
    list: [
      { item: 'Excelente calidad y precio competitivo.' },
      { item: 'Innovación permanente. 400 productos lanzados año a año.' },
      { item: 'Procesos sostenibles.' },
      { item: 'Catálogo premium.' }
    ]
  },
  {
    id: 2,
    title: 'Respaldo',
    subtitle: 'Más de 40 años en el mercado',
    img: Img2,
    list: [
      { item: 'Más de 4.000 tiendas alrededor del mundo.' },
      { item: 'Presencia en 15 países, en 4 de los 5 continentes.' },
      { item: 'Red de 10 tiendas en Colombia.' },
      { item: 'Centro de investigación y desarrollo más grande de América latina.' }
    ]
  },
  {
    id: 3,
    title: 'Incentivos',
    subtitle: 'Premiamos tu compromiso',
    img: Img3,
    list: [
      { item: 'Herramientas para convertirte en embajadora de marca.' },
      { item: 'Experiencias inolvidables que dejan memorias únicas.' },
      { item: 'Talleres de belleza e imagen personal.' },
      { item: 'Capacitaciones premium para el crecimiento de tu negocio.' },
      { item: 'Premios en producto y mayor ganancia.' }
    ]
  },
  {
    id: 4,
    title: 'Sostenibilidad',
    subtitle: 'Cuidamos el planeta',
    img: Img4,
    list: [
      { item: 'Empaques de fuentes renovables y reciclables (plástico vegetal).' },
      { item: '100% de nuestro portafolio es cruelty free, no realizamos pruebas sobre animales.' },
      { item: 'Todos nuestros productos son veganos, no contienen ingredientes de origen animal.   ' }
    ]
  }
]

export default function Special() {
  return (
    <SpecialStyle id="especiales">
      <Container>
        <h2>¿Qué nos hace especiales?</h2>

        <Carousel dots lazyload infinite>
          {items.map(({ id, title, subtitle, img, list }) =>
            <SliderItem key={id} id={id}>
              <img src={img} alt={title} />
              <div>
                <h3>{title}</h3>
                <h4>{subtitle}</h4>
                <ul>
                  {list.map(({ item }) =>
                    <li>{item}</li>
                  )}
                </ul>
              </div>
            </SliderItem>
          )}
        </Carousel>
      </Container>
    </SpecialStyle>
  )
}